<template>
    <CompassModal
        v-model:visible="showModal"
        class="activities-listing-mass-assign"
        size="small"
        :closeOnClickOverlay="false"
        :title="
            $t.__(
                'activities.listing.massActions.ActivitiesListingMassAssign.assign_activities_title',
            )
        "
        :primaryAction="{
            label: $t.__('common.actions.confirm'),
            disabled: isConfirmButtonDisabled,
            action: () => confirmMassAssign(),
            loading: isSubmitting,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                disabled: isSubmitting,
                action: () => $emit('close'),
            },
        ]"
        @closed="$emit('close')"
    >
        <CompassAlert
            v-if="isPhonecallSelected"
            type="informative"
            :description="
                $t.__(
                    'activities.listing.massActions.ActivitiesListingMassAssign.alert_message_phonecall_selected',
                )
            "
            :showClose="false"
            class="activities-listing-mass-assign-alert"
        />
        <span class="typographies-paragraph-medium-bold">
            {{ $t.__('common.labels.several_staff') }}
        </span>
        <CompassSelect
            v-model="selectedStaff"
            :placeholder="
                $t.__(
                    'activities.listing.massActions.ActivitiesListingMassAssign.assign_staff_placeholder',
                )
            "
            multiple
            filterable
            menuClass="activities-listing-mass-assign-select-menu"
            class="activities-listing-mass-assign-select"
        >
            <CompassDropdownOption
                v-for="staff in metas.authors"
                :key="staff.id"
                :label="getFullNameUser(staff)"
                :value="staff.id"
                type="avatar"
                :avatar="formatUserToCompassAvatar(staff)"
            />
        </CompassSelect>
        <span
            class="typographies-paragraph-small-regular activities-listing-mass-assign-info-text-color"
        >
            {{
                $t.__(
                    'activities.listing.massActions.ActivitiesListingMassAssign.assign_activities_info',
                )
            }}
        </span>
        <CompassFormItem
            :label="
                $t.__(
                    'activities.listing.massActions.ActivitiesListingMassAssign.radioGroup_label_assign_type',
                )
            "
            class="activities-listing-mass-assign-radio-group"
        >
            <CompassRadioGroup v-model="assignType">
                <CompassRadio
                    :label="
                        $t.__(
                            'activities.listing.massActions.ActivitiesListingMassAssign.radio_label_replace_staff',
                        )
                    "
                    modelValue="replace_assignees"
                />
                <CompassRadio
                    :label="
                        $t.__(
                            'activities.listing.massActions.ActivitiesListingMassAssign.radio_label_add_staff',
                        )
                    "
                    modelValue="add_assignees"
                />
            </CompassRadioGroup>
        </CompassFormItem>
    </CompassModal>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: activitiesMapGetters } = createNamespacedHelpers('activitiesStores');
import { formatUserToCompassAvatar, getFullNameUser } from 'Helpers/avatarHelper';
import {
    massAssignAddStaff,
    massAssignReplaceStaff,
} from 'api/activities/activitiesMassActionsService';

export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        onError: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showModal: true,
            selectedStaff: [],
            isSubmitting: false,
            assignType: '',
        };
    },
    computed: {
        ...activitiesMapGetters({ metas: 'getMetas' }),
        isConfirmButtonDisabled() {
            return this.selectedStaff.length === 0 || this.assignType === '';
        },
        isPhonecallSelected() {
            return this.selectedActivities.some((activity) => activity.type === 'phonecall');
        },
    },
    methods: {
        formatUserToCompassAvatar,
        getFullNameUser,
        async confirmMassAssign() {
            try {
                this.isSubmitting = true;
                const assignedStaffIds = Array.isArray(this.selectedStaff)
                    ? this.selectedStaff
                    : [this.selectedStaff];

                await (this.assignType === 'replace_assignees'
                    ? massAssignReplaceStaff(this.selectedActivities, assignedStaffIds)
                    : massAssignAddStaff(this.selectedActivities, assignedStaffIds));

                this.$emit('close');
                this.onSuccess();
            } catch (error) {
                this.onError(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
<style lang="scss">
.activities-listing-mass-assign {
    .compass-modal__modal__content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);

        .activities-listing-mass-assign-select {
            .compass-select__tag-container,
            .compass-input {
                max-height: 260px;
                overflow-y: auto;
            }
        }

        .activities-listing-mass-assign-alert {
            margin-bottom: var(--spacing-4);
        }

        .activities-listing-mass-assign-info-text-color {
            color: var(--colors-common-text-subtle-default);
        }

        .activities-listing-mass-assign-radio-group {
            margin-top: var(--spacing-4);
        }
    }
}

#compass-dropdown-container {
    .activities-listing-mass-assign-select-menu {
        z-index: 1001;
    }
}
</style>
